import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link, navigate } from 'gatsby';
import React from 'react';
import ActionButton from './ActionButton';
import ColorDropDown from './ColorDropDown';
import If from './If';
import { ImgSoCal } from './StaticImages';
import { TypeOcr, TypeOcrH4 } from './Types';

interface PriceProps {
  price: number;
}
function Price(props: PriceProps) {
  return <TypeOcr mb={3}>${Math.trunc(props.price)}</TypeOcr>;
}

interface ModGridProps {
  modulargrid?: string;
  retailers?: string;
  tags: string[];
  handle?: string;
}

function ModGrid(props: ModGridProps) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));
  const modgrid =
    !props.tags.includes('Sample Pack') &&
    !props.tags.includes('Reason') &&
    !props.tags.includes('Swag') &&
    !props.tags.includes('Software') &&
    !props.tags.includes('Accessories') &&
    !props.tags.includes('Panel') &&
    !props.tags.includes('Pedals') &&
    !props.tags.includes('NE') &&
    !props.tags.includes('Charity');

  const retailers =
    !props.tags.includes('Sample Pack') &&
    !props.tags.includes('Reason') &&
    !props.tags.includes('Software') &&
    !props.tags.includes('Accessories') &&
    !props.tags.includes('Swag') &&
    !props.tags.includes('NE') &&
    !props.tags.includes('Charity');

  if (isSmall) {
    return (
      <>
        <Stack
          direction={{ sm: 'column', md: 'row' }}
          mb={3}
          mt={3}
          width='98%'
        >
          <If value={retailers}>
            <Link to='/pages/retailers'>
              <Button
                variant='outlined'
                color='info'
                style={{
                  borderRadius: '0px',

                  fontFamily: 'OCR A Std',
                  fontSize: '0.7rem',
                  width: '100%',
                }}
              >
                Authorized Retailers
              </Button>
            </Link>
          </If>
          <If value={modgrid}>
            <a href={props.modulargrid} target='_blank'>
              <Button
                variant='outlined'
                color='info'
                style={{
                  borderRadius: '0px',
                  borderTop: '0px',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflowWrap: 'break-word',
                  display: 'flex',
                  fontFamily: 'OCR A Std',
                  fontSize: '0.70rem',
                  width: '100%',
                }}
              >
                Add to your ModularGrid
              </Button>
            </a>
          </If>
        </Stack>
      </>
    );
  } else {
    return (
      <>
        <Stack
          direction={{ sm: 'column', md: 'row' }}
          mb={3}
          mt={3}
          width='98%'
        >
          <If value={retailers}>
            <Button
              variant='outlined'
              color='info'
              style={{
                borderRadius: '0px',
                alignItems: 'center',
                justifyContent: 'center',
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                display: 'flex',
                fontFamily: 'OCR A Std',
                fontSize: '0.7rem',
                width: '100%',
              }}
              href='/pages/retailers'
            >
              Authorized Retailers
            </Button>
          </If>
          <If value={modgrid}>
            <Button
              variant='outlined'
              color='info'
              style={{
                borderRadius: '0px',
                borderLeft: '0px',
                alignItems: 'center',
                justifyContent: 'center',
                overflowWrap: 'break-word',
                display: 'flex',
                fontFamily: 'OCR A Std',
                fontSize: '0.70rem',
                width: '100%',
              }}
            >
              <a href={props.modulargrid} target='_blank'>
                {' '}
                Add to your ModularGrid
              </a>
            </Button>
          </If>
        </Stack>
      </>
    );
  }
}

export default function ProductDesc(props: any) {
  const Description = props.Description;
  const hasDescription = 'Description' in props;
  const hasPrice =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== 'Free Software' &&
    props.productType !== 'Legacy Hardware';

  const manual =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== 'Apparel' &&
    props.productType !== 'Swag' &&
    props.productType !== 'Panel' &&
    props.manual_link;

  const colordrop =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== '5U' &&
    props.productType !== 'Software' &&
    props.productType !== 'Free Software' &&
    props.productType !== 'Firmware' &&
    props.productType !== 'Legacy Hardware' &&
    props.handle !== 'mystery-module';

  const uIPage = props.handle === 'univer-inter';

  const modBundle = props.tags.includes('Bundle');

  return (
    <Container>
      <Stack ml={2} mr={4}>
        <TypeOcrH4 mt={2} mb={3}>
          {props.title}
        </TypeOcrH4>
        <If value={hasPrice}>
          <Price price={props.variants.nodes[props.variant].priceV2.amount} />
        </If>
        <div
          className='prod-html'
          dangerouslySetInnerHTML={{ __html: props.descriptionHtml }}
        />
        <If value={uIPage}>
          <Link to='/portal/univer-inter'>
            <Button
              variant='outlined'
              style={{
                borderRadius: '0px',
                display: 'flex',
                fontFamily: 'OCR A Std',
              }}
              sx={{ mt: 2, width: '98%' }}
              color='info'
            >
              Configure your Univer Inter
            </Button>
          </Link>
        </If>
        <If value={manual}>
          <Button
            variant='outlined'
            style={{
              borderRadius: '0px',
              display: 'flex',
              fontFamily: 'OCR A Std',
            }}
            sx={{ mt: 2, width: '98%' }}
            color='info'
            href={props.manual_link}
          >
            Product Manual
          </Button>
        </If>
        <ModGrid
          modulargrid={props.modulargrid}
          retailers={props.retailers}
          tags={props.tags}
        ></ModGrid>
        <If value={colordrop}>
          <ColorDropDown
            variant={props.variant}
            setVariant={props.setVariant}
            variants={props.variants}
          />
        </If>
        <ActionButton
          productType={props.productType}
          learnMore={props.learnMore}
          id={props.variants.nodes[props.variant].id}
          pid={props.pid}
          available={
            (props.variants.nodes[props.variant] as any).availableForSale
          }
          name={props.title}
          isLegacy={props.tags.includes('Legacy')}
        />{' '}
        <ImgSoCal />
      </Stack>
    </Container>
  );
}

export function ProductDescWide(props: any) {
  const Description = props.Description;
  const hasDescription = 'Description' in props;
  const hasPrice =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== 'Free Software' &&
    props.productType !== 'Legacy Hardware';

  const manual =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== 'Apparel' &&
    props.productType !== 'Swag' &&
    props.productType !== 'Panel' &&
    props.title !== 'Batverb' &&
    props.manual_link;

  const batmanual = props.title == 'Batverb';

  const colordrop =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== '5U' &&
    props.productType !== 'Software' &&
    props.productType !== 'Free Software' &&
    props.productType !== 'Firmware' &&
    props.productType !== 'Legacy Hardware' &&
    props.productType !== 'Pedal';

  return (
    <Container>
      <Stack direction='row'>
        <Stack ml={2} mr={4} width='100%'>
          <TypeOcrH4 mt={2} mb={3}>
            {props.title}
          </TypeOcrH4>
          <If value={hasPrice}>
            <Price price={props.variants.nodes[props.variant].priceV2.amount} />
          </If>
          <div
            className='prod-html'
            dangerouslySetInnerHTML={{ __html: props.descriptionHtml }}
          />
        </Stack>
        <Stack width='100%' mt={6}>
          <If value={colordrop}>
            <ColorDropDown
              variant={props.variant}
              setVariant={props.setVariant}
              variants={props.variants}
            />
          </If>
          <ActionButton
            productType={props.productType}
            learnMore={props.learnMore}
            id={props.variants.nodes[props.variant].id}
            pid={props.pid}
            available={
              (props.variants.nodes[props.variant] as any).availableForSale
            }
            name={props.title}
            isLegacy={props.tags.includes('Legacy')}
          />
          <If value={manual}>
            <Button
              variant='outlined'
              style={{
                borderRadius: '0px',
                display: 'flex',
                fontFamily: 'OCR A Std',
              }}
              sx={{ mt: 2, width: '98%' }}
              color='info'
              href={props.manual_link}
            >
              Product Manual
            </Button>
          </If>
          <If value={batmanual}>
            <Button
              variant='outlined'
              style={{
                borderRadius: '0px',
                display: 'flex',
                fontFamily: 'OCR A Std',
              }}
              sx={{ mt: 2, width: '98%' }}
              color='info'
              href={props.manual_link}
            >
              BatManual
            </Button>
          </If>
          <If value={props.quickstart}>
            <Button
              variant='outlined'
              style={{
                borderRadius: '0px',
                display: 'flex',
                fontFamily: 'OCR A Std',
              }}
              sx={{ mt: 2, width: '98%' }}
              color='info'
              href={props.quickstart}
            >
              Quickstart Guide
            </Button>
          </If>
          <ModGrid
            modulargrid={props.modulargrid}
            retailers={props.retailers}
            tags={props.tags}
          ></ModGrid>
          <ImgSoCal />
        </Stack>
      </Stack>
    </Container>
  );
}
